import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		component: both("login"),
	},
	{
		path: '/template',
		name: 'template',
		component: both("template"),
	},
	{
		path: '/',
		name: '',
		component: both("Home"),
		redirect: '/index',
		children: [
			{
				path: 'index',
				component: both("index"),
				name: '首页'
			},
			{
				path: 'system_user',
				component: both("system/user"),
				name: '用户管理',
				meta: { roles: ['ROLE_ADMIN'] }
			},
			{
				path: 'system_log',
				component: both("system/log"),
				name: '操作日志',
				meta: { roles: ['ROLE_ADMIN'] }
			},
			{
				path: 'system_msg',
				component: both("system/msg"),
				name: '消息'
			},
			{
				path: 'system_project',
				component: both("system/project"),
				name: '项目管理'
			},
			{
				path: 'system_project_info',
				component: both("system/project_info"),
				name: '项目管理详情'
			},
			{
				path: 'mng_labor',
				component: both("mng/labor"),
				name: '劳务分包价格库'
			},
			{
				path: 'mng_material',
				component: both("mng/material"),
				name: '材料价格库'
			},
			{
				path: 'mng_auxiliary',
				component: both("mng/auxiliary"),
				name: '辅材价格库'
			},
			{
				path: 'mng_machinery',
				component: both("mng/machinery"),
				name: '机械价格库'
			},
			{
				path: 'mng_self_learn_training',
				component: both("mng/self_learn_training"),
				name: '自学习训练工作台',
				meta: { roles: ['ROLE_ADMIN'] }
			},



			
			// {
			// 	path: 'mng_material',
			// 	component: both("mng/material"),
			// 	name: '材料价格库'
			// },
			// {
			// 	path: 'mng_labor',
			// 	component: both("mng/labor"),
			// 	name: '劳务/分包限价库'
			// },
			// {
			// 	path: 'mng_equipment',
			// 	component: both("mng/equipment"),
			// 	name: '机械价格库'
			// },
			// {
			// 	path: 'mng_auxiliary',
			// 	component: both("mng/auxiliary"),
			// 	name: '辅材价格库'
			// },
			// {
			// 	path: 'mng_measure',
			// 	component: both("mng/measure"),
			// 	name: '总价措施库'
			// }
		],
	},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js